import { observer } from 'mobx-react-lite'
import { Error, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldHighlight, TextField } from 'shared/ui/TextField'
import { type ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'
import styles from 'pages/auth/pages/login/ui/Login/ui/LoginForm/styles.module.scss'

type ICheckCurrentPasswordModalProps = {
  store: ProfileStore
}

export const ChangeEmailModal = observer(({ store }: ICheckCurrentPasswordModalProps) => {
  const { newEmail, setNewEmail, errorsMap, loading } = store
  const emailError = errorsMap.get('email')

  return (
    <div>
      <Typography
        variant='body-md-medium'
        ariaLabel='Reset password description'
        tag={'div'}
        marginTop={4}
      >
        New email address
      </Typography>
      <Typography
        variant='body-md-regular'
        color='var(--content-primary-tertiary)'
        ariaLabel='Reset password description'
        tag={'div'}
        marginTop={4}
        marginBottom={24}
      >
        Update the email address used for your account
      </Typography>
      <TextField
        InputProps={{
          placeholder: 'Enter new email address',
        }}
        variant='stroke'
        size='medium'
        value={newEmail}
        onChange={setNewEmail}
        disabled={loading}
        className={styles.emailInput}
        mainActions={[
          makeTextFieldAutoFocus({ withFocus: true }),
          makeTextFieldHighlight({ mode: 'error', highlight: !!emailError }),
        ]}
      />
      <Error type={'text'} error={emailError} />
    </div>
  )
})
